import { LoginDetails } from "../types/login";

type LoginPayload = Record<string, unknown>;

/** companyName from POST /api/auth/login (Sage X3, camelCase or PascalCase). */
export function getLoginCompanyName(
  details: LoginDetails | LoginPayload | null | undefined
): string {
  if (!details) return "";
  const raw = details as LoginPayload;
  return String(raw.companyName ?? raw.CompanyName ?? "").trim();
}

/** Maps login payload into Redux auth state. */
export function normalizeLoginResponse(raw: LoginPayload): LoginDetails {
  const token = String(raw.token ?? raw.Token ?? "");
  const role = String(raw.role ?? raw.Role ?? "");

  return {
    id: (raw.id ?? raw.Id ?? "") as string | number,
    email: String(raw.email ?? raw.Email ?? raw.userName ?? raw.UserName ?? ""),
    userName: String(raw.userName ?? raw.UserName ?? ""),
    firstName: String(raw.firstName ?? raw.FirstName ?? ""),
    lastName: String(raw.lastName ?? raw.LastName ?? ""),
    token,
    role,
    mustChangePassword: Boolean(raw.mustChangePassword ?? raw.MustChangePassword),
    companyName: getLoginCompanyName(raw),
  };
}
